<template>
  <div class="auth-wrapper d-flex no-block justify-content-center align-items-center" style="">
    <div class="auth-box">
      <div id="loginform">
        <div class="logo">
          <span class="db">
            <img alt="logo" src="../../../assets/images/logo/logo-icon-lg.png" style="width:40px; height:auto;">
            <img alt="logo" src="../../../assets/images/logo/logo-text-lg.png" style="width:100px; height:auto;">
          </span>
          <p />
          <h5 class="font-medium m-b-20">
            Welcome back!
          </h5>
          <p />
        </div>
        <!-- Form -->
        <div class="row">
          <div class="col-12">
            <form id="loginform1" class="form-horizontal m-t-20" @submit.prevent="login">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span id="basic-addon" class="input-group-text"><i class="ti-user" /></span>
                </div>
                <input v-model="credentials.email" v-validate="'required|email'" name="email" aria-describedby="basic-addon1" aria-label="Email" class="form-control form-control-lg" placeholder="Email" type="text">
              </div>
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span id="basic-addon2" class="input-group-text"><i class="ti-pencil" /></span>
                </div>
                <input v-model="credentials.password" v-validate="'required'" name="password" aria-describedby="basic-addon1" aria-label="Password" class="form-control form-control-lg" placeholder="Password" type="password">
              </div>
              <div class="form-group row">
                <div class="col-md-12">
                  <div class="custom-control custom-checkbox">
                    <input id="customCheck1" class="custom-control-input" type="checkbox">
                    <label class="custom-control-label" for="customCheck1">Remember me</label>
                    <a id="to-recover" class="text-dark float-right" href="javascript:void(0)"><i class="fa fa-lock m-r-5" /> Forgot Password?</a>
                  </div>
                </div>
              </div>
              <div class="form-group text-center">
                <div class="col-xs-12 p-b-20">
                  <button class="btn btn-block btn-lg btn-dribbble" type="submit">
                    Log In
                  </button>
                </div>
              </div>
              <!--                            <div class="form-group m-b-0 m-t-10">-->
              <!--                                <div class="col-sm-12 text-center">-->
              <!--                                    Don't have an account?-->
              <!--                                    <router-link :to="{ name: 'signup'}" class="text-info m-l-5"><b>Sign up</b></router-link>-->
              <!--                                    to be invited.-->
              <!--                                </div>-->
              <!--                            </div>-->
              <hr>
              <div class="form-group m-b-0 m-t-10">
                <div class="col-sm-12 text-center text-muted">
                  Release {{ this.$parent.version }}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div id="recoverform">
        <div class="logo">
          <span class="db">
            <img alt="logo" src="../../../assets/images/logo/logo-icon-lg.png" style="width:40px; height:auto;">
            <img alt="logo" src="../../../assets/images/logo/logo-text-lg.png" style="width:100px; height:auto;">
          </span>
          <p />
          <h5 class="font-medium m-b-20">
            Recover Password
          </h5>
          <span>Enter your Email and instructions will be sent to you!</span>
        </div>
        <div class="row">
          <div class="col-12">
            <form id="recover" class="form-horizontal m-t-20" @submit.prevent="reset">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  <span id="basic-addon1" class="input-group-text"><i class="ti-user" /></span>
                </div>
                <input v-model="email" v-validate="'required|email'" name="newemail" aria-describedby="basic-addon1" aria-label="Email" class="form-control form-control-lg" placeholder="Email" type="text">
              </div>

              <div class="form-group text-center">
                <div class="col-xs-12 p-b-20">
                  <button class="btn btn-block btn-lg btn-dribbble" type="submit">
                    Reset
                  </button>
                </div>
              </div>
              <hr>
              <div class="form-group m-b-0 m-t-10">
                <div class="col-sm-12 text-center text-muted">
                  Release {{ this.$parent.version }}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      $SITE_URI: this.$SITE_URI,
      loading: false,
      credentials: {
        email: '',
        password: ''
      },
      email: '',
      loggingIn: false,
      error: '',
      $TIMEOUT: this.$TIMEOUT
    }
  },
  mounted () {
    this.init()
    // this.$parent.release();
  },
  methods: {
    init () {
      $('[data-toggle="tooltip"]').tooltip()
      $('.preloader').fadeOut()

      $('#to-recover').on('click', function () {
        $('#loginform').slideUp()
        $('#recoverform').fadeIn()
      })
    },
    checkCurrentLogin () {
      if (this.currentUser) {
        this.$router.replace(this.$route.query.redirect || '/')
      }
    },
    async login () {
      const self = this
      this.submitted = true
      const valid = await this.$validator.validateAll('loginform1')
      if (valid) {
        try {
          self.loading = true
          const reply = await this.$accounts.post('auth/login', this.credentials)
          await this.loginSuccessful(reply)
          await Promise.all([
            this.cachingAddressBooks()
          ])
        } catch (e) {
          console.error(e)
          this.loginFailed(e)
        }
      }
    },
    async loginSuccessful (reply) {
      try {
        this.loading = false
        const token = reply.data.token
        if (!token) {
          this.loginFailed()
          return
        }
        if (reply.data.group_id) {
          this.$store.commit('SET_ACTIVE_GROUP_ID', reply.data.group_id)
        }
        if (reply.data.wallet_id) {
          this.$store.commit('SET_ACTIVE_WALLET', reply.data.wallet_id)
        }
        this.$store.commit('LOGIN', reply.data)
        if (reply.data.group_id) {
          const groupReply = await this.$api.get(`/groups/groups/${reply.data.group_id}`)
          this.$store.commit('SET_ACTIVE_GROUP', groupReply.data)
        } else {
          this.$router.push({ name: 'groups' })
          return
        }

        this.$router.replace(this.$route.query.redirect || '/')
      } catch (e) {
        console.error(e)
        this.loginFailed()
      }
    },
    loginFailed (err) {
      console.log(err)
      this.loading = false
      const data = err.response.data
      if (data.status === 404) {
        this.$toastr.e('Profile not found!', 'Error')
      } else {
        this.$toastr.e('Authentication Error', 'Error')
      }

      this.error = 'Login failed!'
      this.$store.dispatch('logout')
      delete localStorage.token
    },

    async cachingAddressBooks () {
      try {
        const reply1 = await this.$accounts.get('/addressbook/user')
        this.$store.commit('USER_ADDRESS_BOOK', reply1.data)
      } catch (e) {
        console.log(e)
      }
    },

    reset () {
      const self = this
      this.$validator.validateAll('recover')
        .then(result => {
          if (result) {
            self.loading = true
            console.log(this.$SITE_URI + '/auth/resetpwd')
            this.$accounts.post('/forgotPassword', {
              email: this.email,
              siteuri: this.$SITE_URI + '/auth/resetpwd'
            })
              .then(() => {
                this.$swal({
                  type: 'success',
                  title: 'Mail Sent',
                  text: 'You will receive password reset link on your given email address.',
                  timer: 5000
                })
              })
              .catch(() => {
                this.$swal({
                  type: 'error',
                  title: 'Error in sending mail',
                  timer: 5000
                })
              })
          }
        })
    }
  }
}
</script>

<style scoped>
.auth-wrapper {
  background: linear-gradient(
      0deg,
      rgba(54, 64, 78, 0.75),
      rgba(54, 64, 78, 0.75)
    ),
    url(../../../assets/images/big/harvest.jpg);
  background-size: cover;
}
</style>
